export default __webpack_public_path__ + "static/media/vf-priority-changed.dda81bbd.svg";